import { render, staticRenderFns } from "./EditProtospelling.vue?vue&type=template&id=1b2fea28&scoped=true&"
import script from "./EditProtospelling.vue?vue&type=script&lang=js&"
export * from "./EditProtospelling.vue?vue&type=script&lang=js&"
import style0 from "./EditProtospelling.vue?vue&type=style&index=0&id=1b2fea28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2fea28",
  null
  
)

export default component.exports